import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { THERAPIST_LOGO } from '../../media';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { labelKey: 'nav.about', path: '/' },
    { labelKey: 'nav.services', path: '/services' },
    // { labelKey: 'nav.insights', path: '/insights' },
    { labelKey: 'nav.credentials', path: '/credentials' },
    { labelKey: 'nav.contact', path: '/contact' },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setScrolled(window.scrollY > 20);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-warm-white backdrop-blur-sm border-b border-sage/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
        <NavLink to="/" className="flex items-center gap-3 group">
          <img
            src={THERAPIST_LOGO}
            alt="Mirela Logo"
            className="h-9 w-auto object-contain"
          />
        </NavLink>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = link.path === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(link.path);
            return (
              <NavLink
                key={link.path}
                to={link.path}
                className={`relative text-sm font-inter font-medium tracking-wide transition-colors duration-200 whitespace-nowrap pb-0.5
                  ${isActive ? 'text-beige' : 'text-text-muted hover:text-charcoal'}
                `}
              >
                {t(link.labelKey)}
                <span
                  className={`absolute bottom-0 left-0 right-0 h-px bg-sage transition-transform duration-300 origin-center ${
                    isActive ? 'scale-x-100' : 'scale-x-0'
                  }`}
                />
              </NavLink>
            );
          })}
          {/*<LanguageSwitcher variant="light" /> Language switcher is hella removed*/}
          <NavLink
            to="/contact"
            className="whitespace-nowrap ml-1 px-5 py-2 rounded-md bg-beige text-white text-sm font-inter font-medium hover:bg-beige/80 transition-colors duration-200 cursor-pointer"
          >
            {t('nav.cta')}
          </NavLink>
        </nav>

        {/* Mobile: lang switcher + hamburger */}
        <div className="md:hidden flex items-center gap-3">
          {/*<LanguageSwitcher variant="light" /> language switcher on mobile removed*/}
          <button
            className="w-9 h-9 flex items-center justify-center text-charcoal cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-canvas border-t border-sage/10 px-6 py-5 flex flex-col gap-4">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className="text-charcoal text-base font-inter font-medium py-1 cursor-pointer"
            >
              {t(link.labelKey)}
            </NavLink>
          ))}
          <NavLink
            to="/contact"
            className="whitespace-nowrap mt-1 px-5 py-2.5 rounded-md bg-beige text-white text-sm font-inter font-medium text-center cursor-pointer"
          >
            {t('nav.cta')}
          </NavLink>
        </div>
      )}
    </header>
  );
}
